import { render, staticRenderFns } from "./CustomizeMetalQ.vue?vue&type=template&id=a152f950&scoped=true"
import script from "./CustomizeMetalQ.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalQ.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalQ.vue?vue&type=style&index=0&id=a152f950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152f950",
  null
  
)

export default component.exports